<template>
  <div>
    <h1><img src="../assets/main.png" alt="TITLE" /></h1>
    <div class="white-area">
      <p class="text--bold">「イベント名」開催決定！</p>
      <p class="text--midium">
        参加ご希望の方は、下記の応募要項および応募規約をご確認のうえご応募ください。
      </p>
      <a class="event-link" href="">イベントの詳細はこちら</a>
    </div>

    <div class="details bg-color1">
      <p>開催概要</p>
      <div class="inner">
        <dl>
          <dt>●プレゼント内容</dt>
          <dd>
            「ENERYGY CHARGE LIVE(仮) feat. ナオト・インティライミ」無料ご招待
          </dd>
        </dl>
        <dl>
          <dt>●開催⽇時</dt>
          <dd>2020年4⽉7⽇（⽕）18:00〜20:00</dd>
        </dl>
        <dl>
          <dt>●開催場所</dt>
          <dd>
            東京都 ⼭⼿線沿線エリア<br />※具体的な開催場所は当選者の⽅のみにご連絡します
          </dd>
        </dl>
        <dl>
          <dt>●⼊場料</dt>
          <dd>無料</dd>
        </dl>
        <dl>
          <dt>●当選⼈数</dt>
          <dd>抽選で100名様</dd>
        </dl>
      </div>
    </div>
    <div class="details bg-color2">
      <p>応募要項</p>
      <div class="inner">
        <dl>
          <dt>●応募資格</dt>
          <dd>
            モバイルバッテリーレンタルサービス「充レン」公式LINEアカウントを友だち登録し、本フォームよりご応募いただいた方
          </dd>
        </dl>
        <dl>
          <dt>●応募締切</dt>
          <dd><span class="color-red">2020年3⽉26⽇（⽊）23:59</span></dd>
        </dl>
        <dl>
          <dt>●抽選・当選者発表について</dt>
          <dd>
            厳選な抽選の上、当選通知をもって発表にかえさせていただきます<br />※当選者には3⽉中に当選通知をLINEメッセージにてご連絡します
          </dd>
        </dl>
      </div>
    </div>
    <p class="title--black">応募フォーム</p>
    <form action="" name="form1">
      <div class="form__inner">
        <p class="form__text--bold required">●ご参加⼈数</p>
        <p class="form__text--comment">
          ※1回のご応募で2名様まで参加いただけます
        </p>
        <div class="flex">
          <div class="radio">
            <input
              v-model="numberOfPeople"
              id="radio01-1"
              class="radio-input"
              :value="1"
              name="people"
              type="radio"
            />
            <label for="radio01-1" class="radio-label">1名</label>
          </div>
          <div class="radio">
            <input
              v-model="numberOfPeople"
              id="radio01-2"
              class="radio-input"
              :value="2"
              name="people"
              type="radio"
            />
            <label for="radio01-2" class="radio-label">2名</label>
          </div>
        </div>
      </div>
      <div class="form__inner">
        <p class="form__text--bold required">●アンケート</p>
        <p class="form__text--comment">
          サービス向上のため、アンケートにご協⼒ください。
        </p>
        <p class="form__text--bold">・性別</p>
        <div class="flex">
          <div class="radio">
            <input
              v-model="gender"
              id="radio02-1"
              class="radio-input"
              value="male"
              name="gender"
              type="radio"
            />
            <label for="radio02-1" class="radio-label">男性</label>
          </div>
          <div class="radio">
            <input
              v-model="gender"
              id="radio02-2"
              class="radio-input"
              value="female"
              name="gender"
              type="radio"
            />
            <label for="radio02-2" class="radio-label">⼥性</label>
          </div>
          <div class="radio radio--big">
            <input
              v-model="gender"
              id="radio02-3"
              class="radio-input"
              value="notToSay"
              name="gender"
              type="radio"
            />
            <label for="radio02-3" class="radio-label"
              >その他・回答しない</label
            >
          </div>
        </div>
        <p class="form__text--bold">・年代</p>
        <div class="flex">
          <div class="radio">
            <input
              v-model="generation"
              id="radio03-1"
              class="radio-input"
              value="10"
              name="generation"
              type="radio"
            />
            <label for="radio03-1" class="radio-label">〜10代</label>
          </div>
          <div class="radio">
            <input
              v-model="generation"
              id="radio03-2"
              class="radio-input"
              value="20"
              name="generation"
              type="radio"
            />
            <label for="radio03-2" class="radio-label">20代</label>
          </div>
          <div class="radio">
            <input
              v-model="generation"
              id="radio03-3"
              class="radio-input"
              value="30"
              name="generation"
              type="radio"
            />
            <label for="radio03-3" class="radio-label">30代</label>
          </div>
          <div class="radio">
            <input
              v-model="generation"
              id="radio03-4"
              class="radio-input"
              value="40"
              name="generation"
              type="radio"
            />
            <label for="radio03-4" class="radio-label">40代</label>
          </div>
          <div class="radio">
            <input
              v-model="generation"
              id="radio03-5"
              class="radio-input"
              value="50"
              name="generation"
              type="radio"
            />
            <label for="radio03-5" class="radio-label">50代</label>
          </div>
          <div class="radio">
            <input
              v-model="generation"
              id="radio03-6"
              class="radio-input"
              value="60"
              name="generation"
              type="radio"
            />
            <label for="radio03-6" class="radio-label">60代～</label>
          </div>
        </div>
        <p class="form__text--bold">・誕生月</p>
        <p class="form__text--comment">
          誕生月にあわせて還元するサービスを今後提供する予定です
        </p>
        <div class="selectWrap selectWrap--mb5">
          <select v-model="birthMonth" class="select" name="birthMonth" id="">
            <option name="birthMonth" value="選択してください"
              >選択してください</option
            >
            <option name="birthMonth" value="1">1月</option>
            <option name="birthMonth" value="2">2月</option>
            <option name="birthMonth" value="3">3月</option>
            <option name="birthMonth" value="4">4月</option>
            <option name="birthMonth" value="5">5月</option>
            <option name="birthMonth" value="6">6月</option>
            <option name="birthMonth" value="7">7月</option>
            <option name="birthMonth" value="8">8月</option>
            <option name="birthMonth" value="9">9月</option>
            <option name="birthMonth" value="10">10月</option>
            <option name="birthMonth" value="11">11月</option>
            <option name="birthMonth" value="12">12月</option>
          </select>
        </div>
        <p class="form__text--bold">・お住まい<small>（都道府県）</small></p>
        <div class="selectWrap">
          <select v-model="prefecture" class="select" name="area" id="">
            <option name="prefecture" value="選択してください"
              >選択してください</option
            >
            <option name="prefecture" value="北海道">北海道</option>
            <option name="prefecture" value="青森県">青森県</option>
            <option name="prefecture" value="岩手県">岩手県</option>
            <option name="prefecture" value="宮城県">宮城県</option>
            <option name="prefecture" value="秋田県">秋田県</option>
            <option name="prefecture" value="山形県">山形県</option>
            <option name="prefecture" value="福島県">福島県</option>
            <option name="prefecture" value="茨城県">茨城県</option>
            <option name="prefecture" value="栃木県">栃木県</option>
            <option name="prefecture" value="群馬県">群馬県</option>
            <option name="prefecture" value="埼玉県">埼玉県</option>
            <option name="prefecture" value="千葉県">千葉県</option>
            <option name="prefecture" value="東京都">東京都</option>
            <option name="prefecture" value="神奈川県">神奈川県</option>
            <option name="prefecture" value="新潟県">新潟県</option>
            <option name="prefecture" value="富山県">富山県</option>
            <option name="prefecture" value="石川県">石川県</option>
            <option name="prefecture" value="福井県">福井県</option>
            <option name="prefecture" value="山梨県">山梨県</option>
            <option name="prefecture" value="長野県">長野県</option>
            <option name="prefecture" value="岐阜県">岐阜県</option>
            <option name="prefecture" value="静岡県">静岡県</option>
            <option name="prefecture" value="愛知県">愛知県</option>
            <option name="prefecture" value="三重県">三重県</option>
            <option name="prefecture" value="滋賀県">滋賀県</option>
            <option name="prefecture" value="京都府">京都府</option>
            <option name="prefecture" value="大阪府">大阪府</option>
            <option name="prefecture" value="兵庫県">兵庫県</option>
            <option name="prefecture" value="奈良県">奈良県</option>
            <option name="prefecture" value="和歌山県">和歌山県</option>
            <option name="prefecture" value="鳥取県">鳥取県</option>
            <option name="prefecture" value="島根県">島根県</option>
            <option name="prefecture" value="岡山県">岡山県</option>
            <option name="prefecture" value="広島県">広島県</option>
            <option name="prefecture" value="山口県">山口県</option>
            <option name="prefecture" value="徳島県">徳島県</option>
            <option name="prefecture" value="香川県">香川県</option>
            <option name="prefecture" value="愛媛県">愛媛県</option>
            <option name="prefecture" value="高知県">高知県</option>
            <option name="prefecture" value="福岡県">福岡県</option>
            <option name="prefecture" value="佐賀県">佐賀県</option>
            <option name="prefecture" value="長崎県">長崎県</option>
            <option name="prefecture" value="熊本県">熊本県</option>
            <option name="prefecture" value="大分県">大分県</option>
            <option name="prefecture" value="宮崎県">宮崎県</option>
            <option name="prefecture" value="鹿児島県">鹿児島県</option>
            <option name="prefecture" value="沖縄県">沖縄県</option>
          </select>
        </div>
      </div>
      <div class="check">
        <p class="form__text--small">
          上記の応募要項および下記の注意事項をご確認のうえ、同意いただける⽅のみご応募ください。
        </p>
        <input
          v-model="agreement"
          id="check"
          class="check-input"
          value="yes"
          name="check"
          type="checkbox"
        />
        <label for="check" class="check-label required"
          >応募規約・注意事項に同意する</label
        >
      </div>
      <div class="submit">
        <input
          @click="register"
          :disabled="isButtonDisabled || submitting"
          id="submit"
          type="submit"
          name="submit"
          value=""
          :class="{ submitActive: !isButtonDisabled }"
        />
        <label for="submit" class="submit-label target">応募する</label>
      </div>
    </form>
    <div class="terms" id="toggleMenu">
      <p class="terms__title" @click="toggle" :class="{ titleActive: active }">
        <span v-if="active">応募規約</span><span v-else>応募規約を読む</span>
      </p>
      <div class="terms__inner" :class="{ innerActive: active }">
        <p class="terms__text">
          ※イベント内容の録⾳・撮影等はお断りします。<br />
          ※会場までの交通費・宿泊費等は当選者さまのご負担となります。<br />
          ※当選賞品の転売や譲渡、換⾦はできません。<br />
          ※イベント当⽇の天候や出演者の都合等やむをえない事情により、中⽌または内容に変更がある場合があります。<br />
          ※18歳未満の⽅は、保護者の同意を得た上でご応募をお願いいたします。<br />
          ※10歳未満のお⼦様はご参加いただけません。10歳以上15歳未満のお⼦様のご参加の場合は、保護者の同伴が必要となります。<br />
          ※当⽇はスタッフがイベントの模様を録画・撮影いたします。これらの撮影物は「充レン」の各種PR・宣伝等のため弊社Webサイト、SNSや印刷物等に使⽤・掲載させていただくことがあります。予めご承諾願います。<br />
          ※等々
        </p>
        <p class="terms--close" @click="active = !active">閉じる</p>
      </div>
    </div>
    <footer>
      <div class="bg-black">
        <h3>お問い合わせ先</h3>
        <p class="footer__text--midium">《充レンサポートセンター》</p>
        <p class="footer__text--small">
          充レン公式LINEアカウントのメニューから、「Q&A・お問い合わせ」→「その他のお問い合わせ」→「トラブル等」を選択いただき、オペレーターをお呼び出しください。
        </p>
      </div>
      <div class="bg-gray">
        <p>(c) TEPCO Energy Partner, Inc.</p>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      active: false,
      numberOfPeople: 0,
      gender: "",
      generation: "",
      birthMonth: "",
      prefecture: "",
      agreement: false,
      submitting: false
    };
  },
  computed: {
    ...mapGetters(["userId", "displayName", "accessToken"]),
    isButtonDisabled() {
      return (
        this.numberOfPeople === 0 ||
        this.gender === "" ||
        this.generation === "" ||
        this.birthMonth === "" ||
        this.prefecture === "" ||
        this.agreement === false
      );
    }
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
    build_params() {
      return {
        userId: this.userId,
        displayName: this.displayName,
        numberOfPeople: this.numberOfPeople,
        agreement: this.agreement,
        gender: this.gender,
        generation: this.generation,
        birthMonth: this.birthMonth,
        prefecture: this.prefecture
      };
    },
    async register() {
      this.submitting = true;
      await this.$store.dispatch("postRegistration", this.build_params());
      this.submitting = false;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/Registration.vue